import { TableV2 as Table } from "@asayinc/component-library";
import { useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { ROW_OPTIONS } from "src/constants/options/rowOptions";
import { useTablePagination } from "src/hooks/useTablePagination";
import { useAdditionalMailingsQuery } from "src/store/additionalMailing";
import { getColumnData, getColumns, getRowData } from "./utils";
import { IAdditionalMailing } from "src/store/additionalMailing/types";
import { ScrollContainer } from "src/components/containers/ScrollContainer";

export function IssuerAdditionalMailings() {
  const { id: issuerId } = useParams() as { id: string };
  const navigate = useNavigate();

  const {
    getSort,
    offset,
    limit,
    ordering,
    onChangePage,
    onChangeRows,
    onOrderingChange,
  } = useTablePagination();

  const { data, isFetching, isLoading } = useAdditionalMailingsQuery({
    offset,
    limit,
    ordering,
    issuerId,
  });

  const paginateProps = {
    onChangePage,
    onChangeRows,
    rowOptions: ROW_OPTIONS,
    count: data?.count || 0,
    page: Math.floor(offset / limit) + 1,
    rowsPerPage: limit,
  };

  const handleRowClick = (event: IAdditionalMailing) => {
    const { id } = event;
    navigate(`/additional-mailings/${id}/details`);
  };

  const columns = useMemo(() => getColumns(), []);
  const columnData = useMemo(() => {
    return getColumnData({
      getSort,
      onOrderingChange,
    });
  }, [getSort, onOrderingChange]);
  const rowData = getRowData(data?.results || [], handleRowClick);

  return (
    <ScrollContainer sx={{ pt: 8, pb: 10, pl: 10, pr: 6.25 }}>
      <Table
        count={data?.count || 0}
        columnData={columnData}
        columns={columns}
        isFetching={isFetching}
        isLoading={isLoading}
        noResultsData={{
          title: "No Additional Mailings found for this issuer",
          subtitle: "Sorry, there are no Additional Mailings for this issuer.",
        }}
        paginateProps={paginateProps}
        rows={rowData}
        tableMinWidth={900}
        title="Additional Mailings"
        titleVariant="subtitle2"
        toolbarInside
      />
    </ScrollContainer>
  );
}
